import { SyncDescriptor } from 'vscode/vscode/vs/platform/instantiation/common/descriptors';
import './vscode/src/vs/workbench/contrib/timeline/browser/timeline.contribution.js';
import './vscode/src/vs/workbench/contrib/localHistory/browser/localHistory.contribution.js';
import { ITimelineService } from 'vscode/vscode/vs/workbench/contrib/timeline/common/timeline.service';
import { TimelineService } from './vscode/src/vs/workbench/contrib/timeline/common/timelineService.js';

function getServiceOverride() {
    return {
        [( ITimelineService.toString())]: new SyncDescriptor(TimelineService, [], true)
    };
}

export { getServiceOverride as default };
